<template>
  <div class="compromisso-servico-form">
    <!-- Basic Information Box -->
    <box 
      type="primary" 
      :title="t('Informações básicas')" 
      elem-id="boxInformacoesBasicasCompromissoServico">
      
      <dl class="dl-horizontal" v-if="isEditMode">
        <dd><b>ID:</b> {{ compromissoServicoData.compromisso_servico_id }}</dd>
        <dd><b>{{ t('Status') }}:</b> {{ compromissoServicoData.status_label }}</dd>
      </dl>
    </box>

    <!-- Orcamento Servico Box -->
    <box 
      type="primary" 
      :title="t('Serviço do orçamento')" 
      elem-id="boxOrcamentoServicoCompromissoServico"
      v-if="isEditMode && orcamentoServicoData">
      
      <dl class="dl-horizontal">
        <dd><b>ID:</b> {{ orcamentoServicoData.orcamento_servico_id }}</dd>
        <dd><b>{{ t('Status') }}:</b> {{ orcamentoServicoData.status_label }}</dd>
        <dd><b>{{ t('Serviço') }}:</b> {{ orcamentoServicoData.servico_label }}</dd>
        <dd><b>{{ t('Valor') }}:</b> {{ n(parseFloat(String(orcamentoServicoData.servico_valor ?? 0)) || 0, 'currency') }}</dd>
        <dd><b>{{ t('Quantidade') }}:</b> {{ orcamentoServicoData.orcamento_servico_qtd }}</dd>
        <dd><b>{{ t('Tipo') }}:</b> {{ orcamentoServicoData.tipo_label }}</dd>
      </dl>
    </box>

    <!-- Compromisso Servico Box -->
    <box 
      type="primary" 
      :title="t('Serviço do compromisso')" 
      elem-id="boxCompromissoServicoCompromissoServico"
      :validation="() => compromissoServicoValidationErrors.length > 0 ? [] : ['']"
      v-if="isEditMode">
      
      <div class="form-row">
        <div class="form-field">
          <input-number
            data-testid="compromissoservico-input-valor"
            :label="t('Valor')"
            :validation="() => isValorCompromissoServicoValid"
            elem-id="compromisso_servico_input_valor"
            v-model="compromissoServicoData.compromisso_servico_valor"
            :placeholder="t('Valor')">
          </input-number>
        </div>
        <div class="form-field">
          <input-number
            data-testid="compromissoservico-input-qtd"
            :label="t('Quantidade')"
            :validation="() => isQtdCompromissoServicoValid"
            elem-id="compromisso_servico_input_qtd"
            v-model="compromissoServicoData.compromisso_servico_qtd"
            :placeholder="t('Quantidade')">
          </input-number>
        </div>
      </div>

      <p
        v-if="compromissoServicoValidationErrors.length > 0"
        class="validacao-pendencias"
        data-testid="compromissoservico-pendencias">
        {{ t('Falta para salvar') }}: {{ compromissoServicoValidationErrors.join('; ') }}
      </p>
    </box>

    <!-- New Service Box -->
    <box
      type="primary"
      :title="t('Novo serviço')"
      elem-id="boxNovoOrcamentoServicoCompromissoServico"
      :validation="() => novoServicoValidationErrors.length > 0 ? [] : ['']"
      v-if="!isEditMode">

      <div class="form-row" v-if="showVendedorField">
        <div class="form-field" style="flex: 1 1 100%">
          <select-list
            data-testid="compromissoservico-select-vendedor"
            :label="t('Vendedor')"
            :placeholder="t('Escolha o usuário')"
            elem-id="novo_compromisso_servico_select_user_id"
            :itens-select="atendentesOptions"
            :validation="() => isVendedorValid"
            :required="true"
            v-model="novoServicoData.OrcamentoServico.orcamento_servico_user_id">
          </select-list>
        </div>
      </div>

      <div class="form-row" v-if="showTipoField">
        <div class="form-field" style="flex: 1 1 100%">
          <select-list
            data-testid="compromissoservico-select-tipo"
            :label="t('Tipo')"
            :placeholder="t('Escolha o tipo')"
            elem-id="novo_compromisso_servico_select_tipo"
            :itens-select="tiposOptions"
            :validation="() => isTipoValid"
            :required="true"
            v-model="novoServicoData.OrcamentoServico.orcamento_servico_tipo">
          </select-list>
        </div>
      </div>

      <div class="form-row">
        <div class="form-field" style="flex: 1 1 100%">
          <select-list
            data-testid="compromissoservico-select-servico"
            :label="t('Serviço')"
            :placeholder="t('Escolha o serviço')"
            elem-id="novo_compromisso_servico_select_servico"
            :itens-select="servicosOptions"
            :validation="() => isServicoValid"
            :required="true"
            v-model="novoServicoData.OrcamentoServico.servico_id"
            @change="onServicoChange">
          </select-list>
        </div>
      </div>

      <div class="form-row">
        <div class="form-field">
          <input-number
            data-testid="compromissoservico-novo-input-valor"
            :label="t('Valor')"
            :validation="() => isValorNovoServicoValid"
            elem-id="novo_compromisso_servico_input_valor"
            v-model="novoServicoData.OrcamentoServico.servico_valor"
            :placeholder="t('Valor')">
          </input-number>
        </div>
        <div class="form-field">
          <input-number
            data-testid="compromissoservico-novo-input-qtd"
            :label="t('Quantidade')"
            :validation="() => isQtdNovoServicoValid"
            elem-id="novo_compromisso_servico_input_qtd"
            v-model="novoServicoData.OrcamentoServico.orcamento_servico_qtd"
            :placeholder="t('Quantidade')">
          </input-number>
        </div>
      </div>

      <!--
        Chamado 2026-0008: o botão Salvar ficava cinza sem dizer por quê. A lista de
        pendências já era calculada e ninguém a mostrava.
      -->
      <p
        v-if="novoServicoValidationErrors.length > 0"
        class="validacao-pendencias"
        data-testid="compromissoservico-novo-pendencias">
        {{ t('Falta para salvar') }}: {{ novoServicoValidationErrors.join('; ') }}
      </p>
    </box>

    <!-- Orcamento Services Box -->
    <box 
      type="primary" 
      :title="t('Buscar do orçamento')" 
      elem-id="boxBuscarServicoOrcamentoCompromissoServico"
      v-if="!isEditMode && orcamentoServicosEmAberto.length > 0">
      
      <p>{{ t('Orçamento ID') }}: <a data-testid="compromissoservico-editar-orcamento-link" href="javascript:void(0)" @click="editarOrcamento">{{ orcamentoId }} <i class="pi pi-pencil"></i></a></p>
      <hr>

      <div class="servico-row" v-for="orcamento_servico in orcamentoServicosEmAberto" :key="orcamento_servico.orcamento_servico_id">
        <div class="servico-info">
          ID: {{ orcamento_servico.orcamento_servico_id }} |
          {{ orcamento_servico.servico_label }} - {{ n(orcamento_servico.servico_valor ?? 0, 'currency') }}
        </div>
        <div class="servico-action">
          <button
            data-testid="compromissoservico-inserir-button"
            class="p-button p-button-primary p-button-sm"
            @click="adicionarOrcamentoServicoAoCompromisso(orcamento_servico)"
          >
            <i class="pi pi-plus p-button-icon p-button-icon-left" />
            <span class="p-button-label">{{ t('Inserir no compromisso') }}</span>
          </button>
        </div>
      </div>
    </box>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Box from '../../ui/Box.vue';
import InputNumber from '../../inputs/InputNumber.vue';
import SelectList from '../../inputs/SelectList.vue';
import InputText from '../../inputs/InputText.vue';
import InputCurrency from '../../inputs/InputCurrency.vue';
import { eventBus } from '../../eventBus';
import { log } from '../../utils/DebugLogger';
import { useCompromissoServico } from '../../composables/useCompromissoServico';
import { permissionsService } from '../../services/permissionsService';

type Id = number | string;

interface SelectOption {
  ID: Id;
  Name: string;
  Valor?: number | string;
}

interface ServicoRow {
  servico_id: Id;
  servico_nome?: string;
  servicoscategoria_nome?: string;
  servico_valor_padrao?: number | string;
  [key: string]: unknown;
}

interface OrcamentoServicoRow {
  orcamento_servico_id?: Id;
  orcamento_servico_status?: number | string;
  servico_label?: string;
  servico_valor?: number;
  [key: string]: unknown;
}

interface ApiResponse<T = unknown> {
  success?: boolean;
  dados?: T;
  // O envelope da plataforma é {success, dados, error}, tudo minúsculo. As variantes
  // Success/Error nunca chegaram do backend e faziam `response.Error` descartar toda
  // mensagem de erro da API (chamado 2026-0008).
  error?: string;
}

interface CompromissoServicoData {
  compromisso_servico_id: Id;
  compromisso_id: Id;
  orcamento_servico_id: Id;
  compromisso_servico_status: number | string;
  compromisso_servico_qtd: number | string;
  compromisso_servico_valor: number | string;
  compromisso_servico_data_cadastro: string;
  status_label: string;
  compromisso_operador_user_id?: Id;
  [key: string]: unknown;
}

interface NovoServicoData {
  CompromissoServico: {
    compromisso_servico_id: string;
    compromisso_id: Id;
  };
  OrcamentoServico: {
    orcamento_servico_id: string;
    orcamento_id: Id;
    orcamento_servico_qtd: number | string;
    orcamento_servico_tipo: number | string;
    orcamento_servico_user_id: Id;
    orcamento_servico_status?: string;
    servico_valor: number | string;
    servico_id: Id;
  };
}

const props = withDefaults(defineProps<{
  isEditMode?: boolean;
  compromissoId?: number;
  orcamentoId?: number;
  franquiaId?: number;
}>(), {
  isEditMode: false,
  compromissoId: 0,
  orcamentoId: 0,
  franquiaId: 0
});

const emit = defineEmits<{
  'save-success': [];
  'action-success': [];
}>();

const { t, n } = useI18n();

const {
  fetchCompromissoServico,
  saveCompromissoServico: saveCompromissoServicoAPI,
  saveNovoCompromissoServico: saveNovoCompromissoServicoAPI,
  selectServicos,
  buscaOrcamentoServicosPorOrcamentoID,
  adicionarOrcamentoServicoAoCompromisso: adicionarOrcamentoServicoAoCompromissoAPI
} = useCompromissoServico();

const isLoading = ref<boolean>(false);

const compromissoServicoData = reactive<CompromissoServicoData>({
  compromisso_servico_id: '',
  compromisso_id: '',
  orcamento_servico_id: '',
  compromisso_servico_status: '',
  compromisso_servico_qtd: '',
  compromisso_servico_valor: '',
  compromisso_servico_data_cadastro: '',
  status_label: ''
});

const orcamentoServicoData = ref<OrcamentoServicoRow | null>(null);

const novoServicoData = reactive<NovoServicoData>({
  CompromissoServico: {
    compromisso_servico_id: '0',
    compromisso_id: ''
  },
  OrcamentoServico: {
    orcamento_servico_id: '0',
    orcamento_id: '',
    orcamento_servico_qtd: '',
    orcamento_servico_tipo: '',
    orcamento_servico_user_id: '',
    servico_valor: '',
    servico_id: ''
  }
});

const servicosOptions = ref<SelectOption[]>([]);
const servicosComValorPadrao = ref<Record<string, SelectOption>>({});
const atendentesOptions = ref<SelectOption[]>([]);
const orcamentoServicosEmAberto = ref<OrcamentoServicoRow[]>([]);

const tiposOptions = computed<SelectOption[]>(() => [
  { ID: '0', Name: t('Escolha o tipo') },
  { ID: '1', Name: t('Agendado no orçamento') },
  { ID: '2', Name: t('Agendado no compromisso') }
]);

const showVendedorField = computed<boolean>(() => true);

const showTipoField = computed<boolean>(() => true);

const isValorCompromissoServicoValid = computed<boolean>(() => {
  return (Number(compromissoServicoData.compromisso_servico_valor) * 1) >= 0;
});

const isQtdCompromissoServicoValid = computed<boolean>(() => {
  return Number(compromissoServicoData.compromisso_servico_qtd) >= 1;
});

const isStatusCompromissoServicoValid = computed<boolean>(() => {
  return compromissoServicoData.compromisso_servico_status !== 6;
});

const compromissoServicoValidationErrors = computed<string[]>(() => {
  const errors: string[] = [];
  if (!isValorCompromissoServicoValid.value) errors.push(t('Valor inválido'));
  if (!isQtdCompromissoServicoValid.value) errors.push(t('Quantidade inválida'));
  if (!isStatusCompromissoServicoValid.value) errors.push(t('Este serviço do compromisso foi cancelado'));
  return errors;
});

const isVendedorValid = computed<boolean>(() => {
  const v = novoServicoData.OrcamentoServico.orcamento_servico_user_id;
  return Boolean(v) && v !== '' && v !== 0;
});

const isTipoValid = computed<boolean>(() => {
  const v = novoServicoData.OrcamentoServico.orcamento_servico_tipo;
  return Boolean(v) && v !== '' && v !== 0;
});

const isServicoValid = computed<boolean>(() => {
  const v = novoServicoData.OrcamentoServico.servico_id;
  return Boolean(v) && v !== '' && v !== 0;
});

const isValorNovoServicoValid = computed<boolean>(() => {
  return (Number(novoServicoData.OrcamentoServico.servico_valor) * 1) >= 0;
});

const isQtdNovoServicoValid = computed<boolean>(() => {
  return Number(novoServicoData.OrcamentoServico.orcamento_servico_qtd) >= 1;
});

const novoServicoValidationErrors = computed<string[]>(() => {
  const errors: string[] = [];
  if (!isVendedorValid.value) errors.push(t('Escolha o vendedor'));
  if (!isTipoValid.value) errors.push(t('Escolha o tipo'));
  if (!isServicoValid.value) errors.push(t('Escolha o serviço'));
  if (!isValorNovoServicoValid.value) errors.push(t('Valor inválido'));
  if (!isQtdNovoServicoValid.value) errors.push(t('Quantidade inválida'));
  return errors;
});

const canSave = computed<boolean>(() => {
  if (props.isEditMode) {
    return isValorCompromissoServicoValid.value &&
           isQtdCompromissoServicoValid.value &&
           isStatusCompromissoServicoValid.value &&
           !isLoading.value;
  } else {
    return isVendedorValid.value &&
           isTipoValid.value &&
           isServicoValid.value &&
           isValorNovoServicoValid.value &&
           isQtdNovoServicoValid.value &&
           !isLoading.value;
  }
});

const errorMessage = (err: unknown): string =>
  err instanceof Error ? err.message : String(err);

const loadOptions = async (): Promise<void> => {
  try {
    const servicos = await selectServicos() as ServicoRow[] | undefined;
    if (servicos && servicos.length > 0) {
      servicosOptions.value = [
        { ID: 0, Name: t('Escolha o serviço') },
        ...servicos.map((servico) => {
          const servicoOption: SelectOption = {
            ID: servico.servico_id,
            Name: `${servico.servicoscategoria_nome} - ${servico.servico_nome}`
          };

          servicosComValorPadrao.value[String(servico.servico_id)] = {
            ...servicoOption,
            Valor: servico.servico_valor_padrao
          };

          return servicoOption;
        })
      ];
    }

    await loadAtendentes();

    if (props.orcamentoId) {
      await loadOrcamentoServicosEmAberto();
    }
  } catch (error) {
    log('CompromissoServicoForm', 'loadOptions', 'Error', errorMessage(error));
    eventBus.emit('globalMessage.error', t('Erro ao carregar opções: ') + errorMessage(error));
  }
};

const loadAtendentes = async (): Promise<void> => {
  try {
    const franquiaId = props.franquiaId || 0;

    const atendentes = permissionsService.getAtendentesSelectArrayByFranquiaID(franquiaId) as SelectOption[];

    atendentesOptions.value = [
      { ID: 0, Name: t('Escolha o vendedor') },
      ...atendentes
    ];

    // Chamado 2026-0008: o Operador vende DURANTE o compromisso, e o serviço que ele
    // vendeu é dele. getAtendentesSelectArrayByFranquiaID traz só Franqueado, Gerente e
    // Atendente, então o próprio operador nunca estava na lista, `isVendedorValid` nunca
    // ficava verdadeiro e o botão Salvar não habilitava — era a queixa do chamado. A
    // pré-seleção que já existia logo abaixo depende de `compromisso_operador_user_id`,
    // que só é carregado no modo edição, e por isso nunca alcançava o serviço NOVO.
    const usuarioLogado = permissionsService.getUser();
    if (usuarioLogado && usuarioLogado.sub && permissionsService.isUserInGroups(['Operador'])) {
      const jaNaLista = atendentesOptions.value.some(
        (atendente) => String(atendente.ID) === String(usuarioLogado.sub)
      );

      if (!jaNaLista) {
        atendentesOptions.value.push({
          ID: usuarioLogado.sub,
          Name: permissionsService.getUserNameBySub(usuarioLogado.sub) || usuarioLogado.name || usuarioLogado.username
        });
      }

      if (!props.isEditMode) {
        novoServicoData.OrcamentoServico.orcamento_servico_user_id = usuarioLogado.sub;
      }
    }

    if (compromissoServicoData && compromissoServicoData.compromisso_operador_user_id) {
      const operadorId = compromissoServicoData.compromisso_operador_user_id;
      const operadorExists = atendentesOptions.value.some((atendente) => atendente.ID === operadorId);

      if (!operadorExists) {
        atendentesOptions.value.push({
          ID: operadorId,
          Name: `Operador (ID: ${operadorId})`
        });
      }

      if (!props.isEditMode) {
        novoServicoData.OrcamentoServico.orcamento_servico_user_id = operadorId;
      }
    }
  } catch (error) {
    eventBus.emit('globalMessage.error', t('Erro ao carregar atendentes: ') + errorMessage(error));
  }
};

const loadOrcamentoServicosEmAberto = async (): Promise<void> => {
  try {
    if (props.orcamentoId === 0) {
      orcamentoServicosEmAberto.value = [];
      return;
    }

    // The composable already unwraps the envelope and returns the rows (or []).
    // Reading `.success` off that array kept this box from ever rendering (P0-7).
    const servicos = await buscaOrcamentoServicosPorOrcamentoID(props.orcamentoId) as OrcamentoServicoRow[];
    orcamentoServicosEmAberto.value = servicos.filter((os) => Number(os.orcamento_servico_status) === 2);
  } catch (error) {
    eventBus.emit('globalMessage.error', t('Erro ao carregar serviços do orçamento: ') + errorMessage(error));
  }
};

const onServicoChange = (): void => {
  const servicoId = novoServicoData.OrcamentoServico.servico_id;
  if (servicoId === 0) {
    novoServicoData.OrcamentoServico.servico_valor = 0;
    return;
  }

  const servico = servicosComValorPadrao.value[String(servicoId)];
  if (servico && servico.Valor !== undefined) {
    novoServicoData.OrcamentoServico.servico_valor = servico.Valor;
  }
};

const loadForEdit = async (compromissoServicoId: Id): Promise<void> => {
  try {
    isLoading.value = true;
    log('CompromissoServicoForm', 'loadForEdit', 'Loading compromisso servico ID', compromissoServicoId);

    await loadOptions();

    const data = await fetchCompromissoServico(Number(compromissoServicoId)) as { compromisso_servico?: Partial<CompromissoServicoData>; orcamento_servico?: OrcamentoServicoRow } | undefined;
    log('CompromissoServicoForm', 'loadForEdit', 'Data received', data);

    if (data && data.compromisso_servico) {
      Object.assign(compromissoServicoData, data.compromisso_servico);
      orcamentoServicoData.value = data.orcamento_servico ?? null;
      log('CompromissoServicoForm', 'loadForEdit', 'Data loaded successfully');
    } else {
      throw new Error(t('Compromisso Serviço não encontrado'));
    }
  } catch (error) {
    log('CompromissoServicoForm', 'loadForEdit', 'Error', errorMessage(error));
    eventBus.emit('globalMessage.error', errorMessage(error));
  } finally {
    isLoading.value = false;
  }
};

const saveCompromissoServico = async (): Promise<void> => {
  if (!canSave.value) return;

  try {
    isLoading.value = true;

    const response = await saveCompromissoServicoAPI(compromissoServicoData) as ApiResponse;

    if (response.success) {
      eventBus.emit('globalMessage.success', t('Serviço do compromisso salvo com sucesso!'));
      emit('save-success');
      eventBus.emit('compromisso.servico.saved');
    } else {
      throw new Error(response.error || t('Erro ao salvar serviço do compromisso'));
    }
  } catch (error) {
    eventBus.emit('globalMessage.error', errorMessage(error));
  } finally {
    isLoading.value = false;
  }
};

const saveNovoCompromissoServico = async (): Promise<void> => {
  if (!canSave.value) return;

  try {
    isLoading.value = true;

    const response = await saveNovoCompromissoServicoAPI(novoServicoData) as ApiResponse;

    if (response.success) {
      eventBus.emit('globalMessage.success', t('Novo serviço do compromisso salvo com sucesso!'));
      emit('save-success');
      eventBus.emit('compromisso.servico.saved');
    } else {
      throw new Error(response.error || t('Erro ao salvar novo serviço do compromisso'));
    }
  } catch (error) {
    eventBus.emit('globalMessage.error', errorMessage(error));
  } finally {
    isLoading.value = false;
  }
};

const adicionarOrcamentoServicoAoCompromisso = async (orcamentoServico: OrcamentoServicoRow): Promise<void> => {
  try {
    isLoading.value = true;

    // Agenda_AdicionaOrcamentoServicoNoCompromissoInput: {compromisso_id, servicos[]},
    // each item exactly {orcamento_servico_id, compromisso_servico_valor}. The valor
    // is the orçamento row's unit servico_valor — the same semantics as the agenda
    // wizard and IncluiServicoCompromissoParaServicoOrcamentoJaExistente.
    const inputData = {
      compromisso_id: props.compromissoId,
      servicos: [{
        orcamento_servico_id: Number(orcamentoServico.orcamento_servico_id),
        compromisso_servico_valor: Number(orcamentoServico.servico_valor ?? 0)
      }]
    };

    const response = await adicionarOrcamentoServicoAoCompromissoAPI(inputData) as ApiResponse;

    if (response.success) {
      eventBus.emit('globalMessage.success', t('Serviço adicionado ao compromisso com sucesso!'));
      emit('save-success');
      eventBus.emit('compromisso.servico.saved');
    } else {
      throw new Error(response.error || t('Erro ao adicionar serviço ao compromisso'));
    }
  } catch (error) {
    eventBus.emit('globalMessage.error', errorMessage(error));
  } finally {
    isLoading.value = false;
  }
};

const editarOrcamento = (): void => {
  eventBus.emit('modal.orcamentos.open', { id: props.orcamentoId });
};

const resetForm = (): void => {
  Object.assign(compromissoServicoData, {
    compromisso_servico_id: '',
    compromisso_id: '',
    orcamento_servico_id: '',
    compromisso_servico_status: '',
    compromisso_servico_qtd: '',
    compromisso_servico_valor: '',
    compromisso_servico_data_cadastro: '',
    status_label: ''
  });

  orcamentoServicoData.value = null;

  Object.assign(novoServicoData, {
    CompromissoServico: {
      compromisso_servico_id: '0',
      compromisso_id: ''
    },
    OrcamentoServico: {
      orcamento_servico_id: '0',
      orcamento_id: '',
      orcamento_servico_qtd: '',
      orcamento_servico_tipo: '',
      orcamento_servico_user_id: '',
      servico_valor: '',
      servico_id: ''
    }
  });
};

const initializeForNew = async (): Promise<void> => {
  await loadOptions();

  novoServicoData.OrcamentoServico.orcamento_id = props.orcamentoId;
  novoServicoData.OrcamentoServico.servico_id = 0;
  novoServicoData.OrcamentoServico.servico_valor = 0;
  novoServicoData.OrcamentoServico.orcamento_servico_status = '3';
  novoServicoData.OrcamentoServico.orcamento_servico_qtd = '1';
  novoServicoData.OrcamentoServico.orcamento_servico_tipo = '2';
  novoServicoData.CompromissoServico.compromisso_id = props.compromissoId;
};

const getCompromissoServicoData = (): CompromissoServicoData => {
  return compromissoServicoData;
};

const getNovoServicoData = (): NovoServicoData => {
  return novoServicoData;
};

defineExpose({
  loadForEdit,
  saveCompromissoServico,
  saveNovoCompromissoServico,
  resetForm,
  initializeForNew,
  getCompromissoServicoData,
  getNovoServicoData,
  canSave
});
</script>

<style scoped>
.validacao-pendencias {
  margin: 0;
  color: #b32; /* mesma família do vermelho de erro dos inputs */
  font-size: 0.9em;
}

.form-group {
  margin-bottom: 15px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  margin-bottom: 20px;
}

.form-field {
  flex: 1 1 calc(50% - 8px);
  min-width: 250px;
}

@media (max-width: 768px) {
  .form-field {
    flex: 1 1 100%;
  }
}

.servico-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 15px;
  padding: 10px 0;
  border-bottom: 1px solid #f0f0f0;
}

.servico-info {
  flex: 1;
}

.servico-action {
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .servico-row {
    flex-direction: column;
    align-items: stretch;
  }
  
  .servico-action {
    width: 100%;
  }
  
  .servico-action :deep(.p-button) {
    width: 100%;
  }
}

.dl-horizontal dd {
  margin-left: 0;
  margin-bottom: 5px;
}

.text-right {
  text-align: right;
}
</style>
